import { Form } from 'antd';
import { Button, InputPassword } from 'basic-ui-lib';
import { FooterMobile } from 'layouts/widgets/BottomMobile';
import HeaderMobile from 'layouts/widgets/HeaderMobile';
import styled from 'styled-components';

const ChangePassword = () => {
  const [form] = Form.useForm();

  return (
    <Container>
      <HeaderMobile title='Change Password' />
      <Content>
        <Form layout='vertical' form={form} onFinish={() => {}}>
          <Form.Item label='New Password' name='newPassword'>
            <InputPassword placeholder='Please enter' />
          </Form.Item>
          <Form.Item label='Confirm New Password' name='confirmPassword'>
            <InputPassword placeholder='Please enter' />
          </Form.Item>
        </Form>
      </Content>
      <FooterMobile>
        <Button lg type_second>
          Update
        </Button>
      </FooterMobile>
    </Container>
  );
};

export default ChangePassword;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

const Content = styled.div`
  flex: 1;
  padding: 24px 16px 0px;

  .ant-form-item {
    margin-bottom: 12px;
  }

  .ant-form-item-label > label {
    font-weight: 400;
    font-size: 14px;
    font-family: 'Poppins', sans-serif;
  }
`;
